var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"canvas-container"},[_c('v-stage',{ref:"stage",attrs:{"config":_vm.configKonva},on:{"mousedown":_vm.handleMouseDown,"mousemove":_vm.handleMouseMove,"mouseup":_vm.handleMouseUp,"click":_vm.handleClick}},[_c('v-layer',{ref:"layer",attrs:{"draggable":"true"},on:{"dragmove":_vm.onLayerDragMove,"dragend":_vm.onLayerDragEnd}},[_vm._l((_vm.rects),function(rect){return _c('v-rect',{key:rect.name,attrs:{"config":{
          x: Math.min(rect.x, rect.x + rect.width),
          y: Math.min(rect.y, rect.y + rect.height),
          width: Math.abs(rect.width),
          height: Math.abs(rect.height),
          fillEnable: false,
          strokeEnabled: true,
          stroke: '#000',
          strokeWidth: 1,
          name: rect.name,
          id: 'rect',
          scaleX: rect.scaleX,
          scaleY: rect.scaleY,
          draggable: rect.draggable,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.circles),function(cir){return _c('v-ellipse',{key:cir.name,attrs:{"config":{
          x: cir.x,
          y: cir.y,
          radiusX: Math.abs(cir.radiusX),
          radiusY: Math.abs(cir.radiusY),
          strokeEnabled: true,
          stroke: '#000',
          strokeWidth: 1,
          name: cir.name,
          scaleX: cir.scaleX,
          scaleY: cir.scaleY,
          draggable: cir.draggable,
          fillEnable: false,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.triangles),function(triangle){return _c('v-regular-polygon',{key:triangle.name,attrs:{"config":{
          x: triangle.x,
          y: triangle.y,
          sides: 3,
          radius: Math.abs(triangle.radius),
          strokeEnabled: true,
          strokeWidth: 1,
          stroke: '#000',
          name: triangle.name,
          scaleX: triangle.scaleX,
          scaleY: triangle.scaleY,
          draggable: triangle.draggable,
          fillEnable: false,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.pentagons),function(pentagon){return _c('v-regular-polygon',{key:pentagon.name,attrs:{"config":{
          x: pentagon.x,
          y: pentagon.y,
          sides: 5,
          radius: Math.abs(pentagon.radius),
          strokeEnabled: true,
          strokeWidth: 1,
          stroke: '#000',
          name: pentagon.name,
          scaleX: pentagon.scaleX,
          scaleY: pentagon.scaleY,
          draggable: pentagon.draggable,
          fillEnable: false,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.hexagons),function(hexagon){return _c('v-regular-polygon',{key:hexagon.name,attrs:{"config":{
          x: hexagon.x,
          y: hexagon.y,
          sides: 6,
          radius: Math.abs(hexagon.radius),
          strokeEnabled: true,
          strokeWidth: 1,
          stroke: '#000',
          name: hexagon.name,
          scaleX: hexagon.scaleX,
          scaleY: hexagon.scaleY,
          draggable: hexagon.draggable,
          fillEnable: false,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.arcs),function(arc){return _c('v-arc',{key:arc.name,attrs:{"config":{
          x: arc.x,
          y: arc.y,
          innerRadius: Math.abs(arc.innerRadius),
          outerRadius: Math.abs(arc.outerRadius),
          angle: arc.angle,
          name: arc.name,
          scaleX: arc.scaleX,
          scaleY: arc.scaleY,
          draggable: arc.draggable,
          strokeEnabled: true,
          strokeWidth: 1,
          stroke: '#000',
          fillEnable: false,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.lines),function(line){return _c('v-line',{key:line.name,attrs:{"config":{
          points: line.points,
          offset: line.offset,
          name: line.name,
          strokeEnabled: true,
          strokeWidth: 1,
          stroke: '#000',
          lineCap: 'round',
          lineJoin: 'round',
          scaleX: line.scaleX,
          scaleY: line.scaleY,
          draggable: line.draggable,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.texts),function(text){return _c('v-text',{key:text.name,attrs:{"config":{
          x: text.x,
          y: text.y,
          offset: text.offset,
          text: 'hello world',
          fontSize: Math.abs(text.fontSize),
          fontFamily: 'Arial',
          name: text.name,
          strokeEnabled: false,
          fill: '#000',
          fillEnabled: true,
          scaleX: text.scaleX,
          scaleY: text.scaleY,
          draggable: text.draggable,
        }},on:{"dblclick":_vm.editText,"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.images),function(image){return _c('v-image',{key:image.name,attrs:{"config":{
          x: image.x,
          y: image.y,
          image: image.imageEl,
          width: image.width,
          height: image.height,
          name: image.name,
          scaleX: image.scaleX,
          scaleY: image.scaleY,
          draggable: image.draggable,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.beziers),function(bezier){return _c('v-line',{key:bezier.name,attrs:{"config":{
          points: bezier.points,
          stroke: bezier.stroke || '#000',
          strokeWidth: bezier.strokeWidth || 2,
          lineCap: 'round',
          lineJoin: 'round',
          name: bezier.name,
          scaleX: bezier.scaleX,
          scaleY: bezier.scaleY,
          draggable: bezier.draggable,
          bezier: true,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_vm._l((_vm.paths),function(path){return _c('v-line',{key:path.name,attrs:{"config":{
          points: path.points,
          stroke: path.stroke || '#000',
          strokeWidth: path.strokeWidth || 2,
          lineCap: 'round',
          lineJoin: 'round',
          closed: true,
          name: path.name,
          scaleX: path.scaleX,
          scaleY: path.scaleY,
          draggable: path.draggable,
        }},on:{"dragend":_vm.handleShapeDragEnd}})}),_c('v-rect',{ref:"rectBox",attrs:{"config":{
          ...this.rectBox,
          stroke: '#1D83FF',
          strokeWidth: 0.8,
          fill: 'rgba(29, 131, 255, .2)',
          listening: false,
          id: 'selectBox',
        }}}),_c('v-transformer',{ref:"transformer"})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }